import _http from './_http';
let http = _http;

const baseUrl = '/ping';

export default {
  url: `${http.baseUrl}/${baseUrl}`,
  get() {
    return http
      .get(`${baseUrl}`)
      .then(() => true)
      .catch(({ error }) => error);
  },
};
